import { Button } from "@/components/ui/button";
import { Tooltip } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

interface FixPromptButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const FixPromptButton: React.FC<FixPromptButtonProps> = ({ onClick, disabled }) => {
  return (
    <Tooltip title="Fix my prompt">
      <Button
        sx={{
          textTransform: "capitalize",
          fontSize: "0.25rem",
        }}
        variant={"outline"}
        onClick={onClick}
        disabled={disabled}
        startIcon={<AutoFixHighIcon />}
        className={`text-xs p-2 ml-2`}
      >
        Fix my prompt
      </Button>
    </Tooltip>
  );
};

export default FixPromptButton;